import {
    DirectorAudioTranscriptResponse,
    DirectorSummaryResponse,
} from 'types/insights'
import { fetchGeneralData } from '../fetchData'
import { Apis, ApiSubUrls } from '../../enums/api-constants'
import { fetchAudioData } from './fetchUtil'

export enum AudioPlayerScope {
    Daily = 'DAILY',
    LastWeek = 'LAST_WEEK',
}

export const fetchDirectorSummary = (locationId: string) =>
    fetchGeneralData<DirectorSummaryResponse>(
        `${ApiSubUrls[Apis.INSIGHTS]}/locations/${locationId}/store_briefing`,
    )

export const fetchDirectorAudioSummary = (
    locationId: string,
    scope: AudioPlayerScope,
) =>
    fetchAudioData(
        `${ApiSubUrls[Apis.INSIGHTS]}/locations/${locationId}/audio_summary/period/${scope}`,
    )

export const fetchDirectorAudioTranscript = (
    locationId: string,
    scope: AudioPlayerScope,
) =>
    fetchGeneralData<DirectorAudioTranscriptResponse>(
        `${ApiSubUrls[Apis.INSIGHTS]}/locations/${locationId}/audio_summary/period/${scope}/transcript`,
    )
